//external linker
export const A = (props)=>{
    return <a target="_blank" rel="noopener noreferrer nofollow" href={props.href}>{props.children}</a>
}
